import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
// import { Http, Response, Headers } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../../../app.constants';
import { GetDataService } from '../get-data.service';
import * as io from 'socket.io-client';
// import { staticDD } from '../../../../../config/static_values'
import { User } from './user';
import { RolesAccessData } from './aclData';

@Injectable()
export class AuthService {
    private loggedIn = new BehaviorSubject<boolean>(false); // {1}
    public user: any = null;
    public accessList: any;
    public userData: any;
    public displayImageUrl;
    private displayImageUrlBeh = new BehaviorSubject<any>(false);
    public displayImageUrlObs = this.displayImageUrlBeh.asObservable();
    // tslint:disable-next-line:max-line-length
    public phoneNumberMaskObject = {mask: [ '+' , /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/], guide: false, showMask: false};

    setImageUrl(url) {
        this.displayImageUrlBeh.next(url);
    }

    get isLoggedIn() {
        return this.loggedIn.asObservable(); // {2}
    }


    constructor(
        private router: Router,
        private _http: HttpClient,
        private getdataservice: GetDataService ,
        private config: Configuration,
        private roles: RolesAccessData,

    ) {
        const token = localStorage.getItem('token');

        if (token) {
            this.loggedIn.next(true);
            this.user = JSON.parse(localStorage.getItem('user'));
        }
    }

    linkedinLogin (userObject) {
        this.loggedIn.next(true);
        this.router.navigate(['/disclaimer']);
        this.user = userObject;
        localStorage.setItem('token', this.user.token);
        localStorage.setItem('user', JSON.stringify(this.user));
    }

    login(user: User) {
        const promise = new Promise((resolve, reject) => {
            if (user.email !== '' && user.password !== '') { // {3}
                return this._http.post(`${this.config.ServerApiUrl}/login`, user)
                    // .map((res: Response) => res.json())
                    .subscribe(data => {
                        this.loggedIn.next(true);
                        this.router.navigate(['/disclaimer']);
                        this.user = data;
                        localStorage.setItem('token', this.user.token);
                        localStorage.setItem('user', JSON.stringify(this.user));
                        resolve(data);
                    },
                    err => {
                        reject(err);
                    });
            }
        });
        return promise;
    }

    proxyLogin(associateId) {
        const promise = new Promise((resolve, reject) => {
                return this._http.post(`${this.config.ServerApiUrl}/proxyuser`,{associateId:associateId})
                    .subscribe(data => {
                        console.log('proxyuser',data)
                        this.loggedIn.next(true);
                        this.user = data;
                        localStorage.setItem('token', this.user.token);
                        localStorage.setItem('user', JSON.stringify(this.user));
                        resolve(data);
                        window.location.href = '/disclaimer';
                    },
                    err => {
                        reject(err);
                    });
        });
        return promise;
    }
    proxyLogout() {
        const promise = new Promise((resolve, reject) => {
                return this._http.get(`${this.config.ServerApiUrl}/proxylogout`)
                    .subscribe(data => {
                        console.log('proxyuser', data)
                        this.loggedIn.next(true);
                        this.user = data;
                        console.log('proxyuser2', this.user)
                        localStorage.setItem('token', this.user.token);
                        localStorage.setItem('user', JSON.stringify(this.user));
                        resolve(data);
                        window.location.href = '/disclaimer';
                    },
                    err => {
                        reject(err);
                    });
        });
        return promise;
    }

    

    register(user: User) {
        const promise = new Promise((resolve, reject) => {
            if (user.email !== '' && user.password !== '') { // {3}
                return this._http.post(`${this.config.ServerApiUrl}/register`, user)
                    .subscribe(data => {
                        console.log('response recieved ' + data );
                        this.loggedIn.next(true);
                        resolve(data);
                    },
                    err => {
                        reject(err);
                    });
            }
        });
        return promise;
    }

    signup (user) {
        return this._http.post(`${this.config.ServerApiUrl}/sign-up`, user);
    }

    getUser(userId) {
        if (userId) {
            return this._http.get(`${this.config.ServerApiUrl}/getUser?id=${userId}`);
        }
    }

    getUserByUsername(username) {
        if (username) {
            return this._http.get(`${this.config.ServerApiUrl}/getUserByUsername?username=${username}`);
        }
    }

    getUserByAssociateId(associateId) {
        if (associateId) {
            return this._http.get(`${this.config.ServerApiUrl}/getUserByAssociataeId?id=${associateId}`);
        }
    }

    passwordResetEmail(username) {
        if (username) {
            return this._http.get(`${this.config.ServerApiUrl}/sendPassworResetEmail?username=${username}`);
        }
    }

    logout() {                            // {4}
        this.loggedIn.next(false);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.router.navigate(['/login']);
    }

    linkedinSignUp(userId, isLogin?) {
        return this._http.get(`${this.config.ServerApiUrl}/linkedinSignup?userId=${userId}&isLogin=${isLogin}`);
    }

    linkedinAccessToken(state, userId, access_code) {
        return this._http.get(`${this.config.ServerApiUrl}/linkedinAccessToken?userId=${userId}&state=${state}&acces_code=${access_code}`);
    }

    lineSignUp(userId, isLogin?) {
        return this._http.get(`${this.config.ServerApiUrl}/lineLoginUrl?userId=${userId}&isLogin=${isLogin}`);
    }

    lineAccessToken(state, userId, access_code) {
        return this._http.get(`${this.config.ServerApiUrl}/lineAccessToken?userId=${userId}&state=${state}&acces_code=${access_code}`);
    }


    changePassword(user) {
        return this._http.post(`${this.config.ServerApiUrl}/changePassword`, user);
    }


}
